/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import gql from "graphql-tag";

export const GET_SECTIONS = gql`
query GetSections($filter: SectionFilterInput) {
  getSections(filter: $filter) {
    content {
      id
      name
    }
  }
}
`;

// $input: RoleListInput

// getListOfRole(input: $input) {
//   totalCount
//   data
// }
